import { useState } from 'react';
import { MdCancel } from 'react-icons/md';
import { AiOutlineLoading, AiOutlineClose } from 'react-icons/ai';
import ClientService from '../../../rest/clientService';
import ModalPortal from '../../../components/lib/modalPortal';

export const CancelReservationModal = ({ reservation, isOpen, onClose, onConfirm, loading, requirePin = true }) => {
    const [pin, setPin] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async () => {
        setError('');
        if (requirePin) {
            try {
                const isValid = await ClientService.checkAdminOperationalPin(pin);
                if (!isValid) { setError('PIN incorreto.'); return; }
            } catch (e) {
                setError('Erro de validação.');
                return;
            }
        }
        onConfirm(reservation);
    };

    const handleClose = () => { setPin(''); setError(''); onClose(); };

    if (!isOpen) return null;

    const studentName = reservation?.studentId?.split(' / ')[1] || reservation?.studentId;

    return (
        <ModalPortal>
            <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
                <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md animate-in zoom-in duration-200">
                    <div className="flex justify-between items-center mb-4">
                        <h3 className="text-lg font-bold text-gray-800">Cancelar Reserva #{reservation?.reservationId}</h3>
                        <button onClick={handleClose}><AiOutlineClose /></button>
                    </div>

                    <p className="text-sm text-gray-500 mb-4">
                        Confirmar cancelamento da reserva de <span className="font-bold text-gray-700">{studentName}</span>?
                        {reservation?.paymentMethod && (
                            <span> O pagamento via <span className="font-bold">{reservation.paymentMethod}</span> será estornado.</span>
                        )}
                    </p>

                    {requirePin && (
                        <>
                            <label className="block text-xs font-bold text-gray-500 mb-1 uppercase">PIN Administrativo</label>
                            <input
                                type="password"
                                placeholder="****"
                                className="w-full p-3 border rounded-lg mb-2"
                                value={pin}
                                onChange={(e) => setPin(e.target.value)}
                                onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                            />
                        </>
                    )}

                    {error && <p className="text-red-500 text-xs mb-4 font-bold">{error}</p>}

                    <div className="flex gap-3 mt-2">
                        <button onClick={handleClose} className="flex-1 py-3 bg-gray-100 rounded-lg font-bold text-gray-700">Voltar</button>
                        <button
                            onClick={handleSubmit}
                            disabled={loading}
                            className="flex-1 bg-red-500 text-white font-bold py-3 rounded-lg flex justify-center items-center gap-2"
                        >
                            {loading ? <AiOutlineLoading className="animate-spin" /> : <><MdCancel /> Confirmar</>}
                        </button>
                    </div>
                </div>
            </div>
        </ModalPortal>
    );
};
